import React, { useEffect, useState } from 'react';
import { Input, Select } from '../../../components/ui/Input';
import Secao from '../../../components/ui/Secao';
import { categoriasApi } from '../../../api/produtos';
import { useAuth } from '../../../context/AuthContext';

const TIPOS = [
  { value: 'revenda', label: 'Revenda' },
  { value: 'materia_prima', label: 'Matéria-Prima' }
];

export default function FichaTecnicaTab({ form, onChange, codigoExibido }) {
  const [categorias, setCategorias] = useState([]);
  const { regimeTributario } = useAuth();
  const simplesNacional = regimeTributario === 'simples_nacional';

  useEffect(() => { categoriasApi.listar().then(setCategorias).catch(() => {}); }, []);

  const opcoesCategorias = [{ value: '', label: '(sem categoria)' }, ...categorias.map(c => ({ value: c.id, label: c.nome }))];

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 10, maxWidth: 780 }}>
      <Secao titulo="Identificação">
        <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
          <div style={{ display: 'grid', gridTemplateColumns: '1.6fr 1fr 1fr 1fr', gap: 6 }}>
            <Input label="Nome do Produto" value={form.nome || ''} onChange={e => onChange('nome', e.target.value)} required autoFocus />
            <Input label="Código do Produto" value={codigoExibido || '(gerado ao salvar)'} disabled />
            <Input label="Código Fabricante" value={form.codigo_fabricante || ''} onChange={e => onChange('codigo_fabricante', e.target.value)} />
            <Select label="Tipo de Produto" options={TIPOS} value={form.tipo_produto || 'revenda'} onChange={e => onChange('tipo_produto', e.target.value)} />
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 6 }}>
            <Input label="Descrição do Produto" value={form.descricao || ''} onChange={e => onChange('descricao', e.target.value)} />
            <Input label="Descrição Abreviada" value={form.descricao_abreviada || ''} onChange={e => onChange('descricao_abreviada', e.target.value)} />
          </div>
          <label style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 13 }}>
            <input type="checkbox" checked={!!form.suspenso} onChange={e => onChange('suspenso', e.target.checked ? 1 : 0)} />
            Produto Suspenso/Inativo
          </label>
        </div>
      </Secao>

      <Secao titulo="Classificação">
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, minmax(0, 1fr))', gap: 6 }}>
          <Select label="Categoria" options={opcoesCategorias} value={form.categoria_id || ''} onChange={e => onChange('categoria_id', e.target.value || null)} />
          <Input label="Marca" value={form.marca || ''} onChange={e => onChange('marca', e.target.value)} />
          <Input label="Fabricante" value={form.fabricante || ''} onChange={e => onChange('fabricante', e.target.value)} />
        </div>
      </Secao>

      <Secao titulo="Unidades e Códigos">
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(5, minmax(0, 1fr))', gap: 6 }}>
          <Input label="Unid. Comercial" value={form.unidade_comercial || 'UN'} onChange={e => onChange('unidade_comercial', e.target.value)} />
          <Input label="Unid. Tributável" value={form.unidade_tributavel || 'UN'} onChange={e => onChange('unidade_tributavel', e.target.value)} />
          <Input label="Fator Conversão" type="number" step="0.0001" value={form.fator_conversao ?? 1} onChange={e => onChange('fator_conversao', e.target.value)} />
          <Input label="GTIN Comercial" value={form.gtin || ''} onChange={e => onChange('gtin', e.target.value)} />
          <Input label="GTIN Tributável" value={form.gtin_tributavel || ''} onChange={e => onChange('gtin_tributavel', e.target.value)} />
        </div>
      </Secao>

      <Secao titulo="Peso e Volume">
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, minmax(0, 1fr))', gap: 6 }}>
          <Input label="Peso Bruto (kg)" type="number" step="0.001" value={form.peso_bruto || ''} onChange={e => onChange('peso_bruto', e.target.value)} />
          <Input label="Peso Líquido (kg)" type="number" step="0.001" value={form.peso_liquido || ''} onChange={e => onChange('peso_liquido', e.target.value)} />
          <Input label="Volume (m³)" type="number" step="0.0001" value={form.volume_m3 || ''} onChange={e => onChange('volume_m3', e.target.value)} />
        </div>
      </Secao>

      <Secao titulo="Fiscal">
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, minmax(0, 1fr))', gap: 6 }}>
          <Input label="NCM" value={form.ncm || ''} onChange={e => onChange('ncm', e.target.value)} maxLength={8} />
          <Input label="CEST" value={form.cest || ''} onChange={e => onChange('cest', e.target.value)} maxLength={7} />
          <Input label="Código ANP" value={form.codigo_anp || ''} onChange={e => onChange('codigo_anp', e.target.value)} maxLength={9} />
          <Input label="Código ANVISA" value={form.codigo_anvisa || ''} onChange={e => onChange('codigo_anvisa', e.target.value)} maxLength={13} />
          <Input label="Origem (0-8)" type="number" min="0" max="8" value={form.origem_mercadoria ?? 0} onChange={e => onChange('origem_mercadoria', e.target.value)} />

          {simplesNacional ? (
            <Input label="CSOSN" value={form.csosn || ''} onChange={e => onChange('csosn', e.target.value)} maxLength={4} />
          ) : (
            <Input label="CST ICMS" value={form.cst_icms || ''} onChange={e => onChange('cst_icms', e.target.value)} maxLength={3} />
          )}
          <Input label="CST PIS" value={form.cst_pis || ''} onChange={e => onChange('cst_pis', e.target.value)} maxLength={2} />
          <Input label="CST COFINS" value={form.cst_cofins || ''} onChange={e => onChange('cst_cofins', e.target.value)} maxLength={2} />
          <Input label="CFOP Entrada" value={form.cfop_padrao_entrada || ''} onChange={e => onChange('cfop_padrao_entrada', e.target.value)} maxLength={4} />
          <Input label="CFOP Saída" value={form.cfop_padrao_saida || ''} onChange={e => onChange('cfop_padrao_saida', e.target.value)} maxLength={4} />
        </div>
      </Secao>

      <Secao titulo="Controle de Estoque">
        <div style={{ display: 'flex', gap: 14 }}>
          <label style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 13 }}>
            <input type="checkbox" checked={!!form.controla_lote} onChange={e => onChange('controla_lote', e.target.checked ? 1 : 0)} />
            Controla Lote
          </label>
          <label style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 13 }}>
            <input type="checkbox" checked={!!form.controla_validade} onChange={e => onChange('controla_validade', e.target.checked ? 1 : 0)} />
            Controla Validade
          </label>
          <label style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 13 }}>
            <input type="checkbox" checked={!!form.tem_composicao} onChange={e => onChange('tem_composicao', e.target.checked ? 1 : 0)} />
            Este produto tem composição?
          </label>
        </div>
      </Secao>
    </div>
  );
}
